<template>

    <Forms ref="frmComission"
            :title="'Buscar por Solicitação'"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
            v-on:Clear="Clear"
            v-on:Search="Search"
            v-on:Load ="onLoad"

          >
          <div>
            <div id="form-search">

               <label class="labelseach mt-3">Empreendimento</label>
                    <autocomplete-z ref="EmpreendimentoTypeahead"
                          placeholder="Digite um empreendimento"
                          iconClass="fas fa-building"
                          :ShowCode="false"
                          :serializer="(empreendimento) => empreendimento.nome"
                          :debounceLength="2"
                          :formField="SearchItems.empreendimento"
                          v-on:search="onSearchEmpreendimento"
                          v-on:changeCode="onChangeCodeEmpreendimento"
                           />
              <label class="labelseach mt-3">Cliente</label>
              <autocomplete-z ref="ClienteTypeahead"
                          placeholder="Digite um cliente"
                          iconClass="fas fa-user"
                          :serializer="(cliente) => cliente.nome"
                          :debounceLength="2"
                          :formField="SearchItems.cliente"
                          v-on:search="onSearchCliente"
                          v-on:changeCode="onChangeCodeCliente"
                          :ShowCode="false"
                           />
            <label class="labelseach mt-3" for="txtInsured">Data da Solicitação</label>

            <label class="labelseach mt-3" for="txtInsured">Desde</label>
            <div class="d-flex align-items-end">
              <b-form-datepicker
                v-model ="SearchItems.DataInicio"
                today-button
                label-today-button="Hoje"
                reset-button
                label-reset-button="Limpar"
                close-button
                label-close-button="Fechar"
                placeholder="__/__/__"
                locale="pt-BR"
                :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
            </div>

            <label class="labelseach mt-3" for="txtInsured">Até</label>
            <div class="d-flex align-items-end">
                <b-form-datepicker
                v-model ="SearchItems.DataFinal"
                today-button
                label-today-button="Hoje"
                reset-button
                label-reset-button="Limpar"
                close-button
                label-close-button="Fechar"
                placeholder="__/__/__"
                locale="pt-BR"
                :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
            </div>
            </div>
          </div>
    </Forms>

</template>

<script>
import FormSearchRequest from './formSearchRequest'

export default FormSearchRequest
</script>

<style scoped>
.margem-data{
  margin-bottom: 60%;
}

#form-search{
  display: flex;
  flex-direction: column;
  align-content: center;
}

.labelseach{
  font-weight: 700;
  color: #666;
  font-size: 14px;
  margin-bottom: 5px;
  padding-bottom: 0;
  font-family: Segoe UI;
}

.datepickerinicio{
  font-size: 14px;
}

.datepickerfinal{
  font-size: 14px;
}

#app.zopone .text-third{
  font-size: 16px;
  font-weight: normal;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/changedateofinstallment/components/formSearchRequest/formSearchRequest.vue